export default __webpack_public_path__ + "../staticImages/winefinder-sprite-Aroma_blumig.png";